import { render, staticRenderFns } from "./ModMail.vue?vue&type=template&id=5d064747&"
import script from "./ModMail.vue?vue&type=script&lang=js&"
export * from "./ModMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports